<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-slothtech">
    <router-link class="navbar-brand" to="/">
      <img style="width: 140px;" src="//static.slothtech.io/slothtech/logo-slothtech-verde.png" alt />
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="isDropdownMenu = !isDropdownMenu"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse collapse" :class="{'show': isDropdownMenu}" id="navbarNavDropdown">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a
            class="nav-link"
            target="_blank"
            href="https://forms.gle/qR679fbJDtJ2kA3n7"
          >Propuesta de contenido</a>
        </li>
        <li v-if="false" class="nav-item">
          <router-link to="/live" class="nav-link">Live</router-link>
        </li>
        <li class="nav-item">
          <a href="https://t.me/slothtech" target="_blank" class="nav-link">Comunidad</a>
        </li>
        <li class="nav-item">
          <a href="https://www.instagram.com/sloth.tech/" target="_blank" class="nav-link">Galería</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isDropdownMenu: false
    };
  }
};
</script>